import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeleteInvoiceMutation = graphql.persisted(
  "DeleteInvoice",
  graphql(`
    mutation DeleteInvoice($input: DeleteInvoiceInput!) {
      deleteInvoice(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { DeleteInvoiceMutation };

export function useDeleteInvoice() {
  return useMutation(DeleteInvoiceMutation);
}
